import { ArrowLeftOutlined } from '@ant-design/icons'
import { Grid, Row } from 'antd'
import * as React from 'react'
import { useNavigate } from 'react-router'

import Button from '../General/Button'
import KCol from './KCol'

interface Props {
  title?: React.ReactNode | string
  subtitle?: React.ReactNode | string
  showBackButton?: boolean
  onBack?: () => void
}

const KTitle: React.FC<Props> = ({ title, subtitle, showBackButton, onBack }) => {
  const navigate = useNavigate()
  const { md } = Grid.useBreakpoint()

  const showBack = showBackButton || onBack
  const onBackClick = () => (onBack ? onBack() : navigate(-1))

  return (
    <Row>
      <If condition={showBack && md}>
        <KCol>
          <Button className="text-lg pt-0" type="link" onClick={onBackClick}>
            <ArrowLeftOutlined />
          </Button>
        </KCol>
      </If>
      <KCol>
        <h3 className="mb-0 white-space-normal">{title}</h3>
        {subtitle && <div className="mb-2 text-muted">{subtitle}</div>}
      </KCol>
    </Row>
  )
}

export default KTitle
